import React, { CSSProperties } from "react";
import { OspModal } from "@ospweb/sdk-ui";
import { createCallable } from "react-call";
import { OspModalType } from "@ospweb/sdk-ui/src/modal/types";

import { DrawerH5 } from "../DrawerH5";
import { useIsPc } from "@hooks/useIsPc";

export type EdgenModalProps = Omit<OspModalType, "open" | "centered"> & {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  centered?: boolean;
  wrapperStyle?: CSSProperties;
  /**
   * H5 DrawerH5 下拉关闭；经 EdgenModal 默认 false。
   * 特定场景需手势关时显式传 `swipeToClose: true`。
   */
  swipeToClose?: boolean;
  /** 下拉关闭阈值（px），仅 H5 且 swipeToClose 为 true 时生效 */
  dragThreshold?: number;
};

export const EdgenModal: React.FC<EdgenModalProps> = ({
  children,
  title,
  styles,
  ...otherProps
}) => {
  const [isPc] = useIsPc();

  if (isPc || otherProps?.centered) {
    // PC端使用 OspModal
    return (
      <OspModal centered title={title} styles={styles} {...otherProps}>
        {children}
      </OspModal>
    );
  }

  // 移动端使用 DrawerH5
  return (
    <DrawerH5
      open={otherProps.open}
      onClose={otherProps.onClose}
      title={title}
      zIndex={otherProps.zIndex}
      containerStyle={otherProps.containerStyle}
      containerClassName={otherProps.containerClassName}
      contentStyle={otherProps.contentStyle}
      domClassName={otherProps?.domClassName}
      wrapperStyle={otherProps.wrapperStyle}
      className={otherProps.className}
      maskClosable={otherProps.maskClosable}
      swipeToClose={otherProps.swipeToClose}
      dragThreshold={otherProps.dragThreshold}
    >
      {children}
    </DrawerH5>
  );
};

export type EdgenModalCreateAbleProps = Omit<
  EdgenModalProps,
  "open" | "onClose"
> & {
  /**
   * 旁路关闭（H5 手势/遮罩等触发 onClose）时的业务回调。
   * 特定场景 opt-in；默认仅 `call.end(false)`。
   */
  onDismiss?: () => void;
};

export const EdgenModalCreateAble = createCallable<
  EdgenModalCreateAbleProps,
  boolean
>(({ call, onDismiss, ...props }) => {
  const handleClose = () => {
    onDismiss?.();
    call.end(false);
  };

  return <EdgenModal open={!call.ended} onClose={handleClose} {...props} />;
}, 300);
